import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Constants from '../../../../constants';
import { formatTime } from '../../../../utils/docConsultUtils';
import ARROW_DOWN from '../../../../images/arrow_down.svg';
import './SlotBooking.scss';

const staticText = {
  bookAppointmentFallback: 'Book Appointment',
  loading: 'Loading available slots...',
  errorPrefix: 'Error loading slots: ',
  noSlots: 'No slots available for the selected date and type.',
  viewMore: 'View More Slots',
  viewLess: 'View Less Slots',
};

class SlotBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: '',
      selectedFilter: '',
      selectedSlot: null,
      showAllSlots: false,
    };
  }

  componentDidMount() {
    const { slots } = this.props;
    if (slots && slots.dates && slots.dates.length > 0) {
      this.setState({ selectedDate: slots.dates[0] });
    }
  }

  componentDidUpdate(prevProps) {
    const { slots } = this.props;
    if (slots && slots.dates && slots.dates.length > 0 &&
        (!prevProps.slots || !prevProps.slots.dates || prevProps.slots.dates.length === 0)) {
      this.setState({ selectedDate: slots.dates[0] });
    }
  }

  handleDateSelect = (date) => {
    this.setState({ selectedDate: date, selectedFilter: '', selectedSlot: null, showAllSlots: false });
    const { onDateSelect } = this.props;
    if (onDateSelect) onDateSelect(date);
  }

  handleFilterSelect = (filter) => {
    const { selectedFilter } = this.state;
    this.setState({ selectedFilter: selectedFilter === filter ? '' : filter, selectedSlot: null, showAllSlots: false });
  }

  handleSlotSelect = (slot) => {
    this.setState({ selectedSlot: slot });
    const { onSlotSelect } = this.props;
    const { selectedDate, selectedFilter } = this.state;
    if (onSlotSelect) {
      onSlotSelect({
        date: selectedDate,
        slotId: slot.id,
        startTime: slot.start,
        endTime: slot.end,
        filter: selectedFilter,
      });
    }
  }

  getDateData = () => {
    const { slots } = this.props;
    const { selectedDate } = this.state;
    if (!slots || !slots.data) return null;
    return slots.data.find(dateItem => dateItem.date === selectedDate) || null;
  }

  render() {
    const { slots } = this.props;
    const { selectedDate, selectedFilter, selectedSlot, showAllSlots } = this.state;

    if (!slots) return null;

    const sectionTitle = (slots.sectionInfo && slots.sectionInfo.title) || staticText.bookAppointmentFallback;
    const dateData = this.getDateData();
    const groups = (dateData && dateData.slotGroups) || [];
    const allSlots = groups.reduce((acc, group) => acc.concat(group.slots || []), []);
    const filteredSlots = selectedFilter
      ? ((groups.find(group => group.title === selectedFilter) || {}).slots || [])
      : allSlots;
    const visibleSlots = showAllSlots || filteredSlots.length <= Constants.SLOT_DISPLAY_CLAMP
      ? filteredSlots
      : filteredSlots.slice(0, Constants.SLOT_DISPLAY_CLAMP);

    return (
      <div className="slotBooking">
        <h3 className="slotBookingTitle">{sectionTitle}</h3>

        {slots.loading && <div className="slotLoadingState">{staticText.loading}</div>}
        {slots.error && <div className="slotErrorState">{staticText.errorPrefix}{slots.error}</div>}

        {!slots.loading && !slots.error && slots.data && slots.data.length > 0 && (
          <div>
            {/* Date tabs */}
            <div className="csSlotCalendar">
              <div className="csDateRow">
                {slots.data.map((dateItem, index) => (
                  <div className="csDateItemWrapper" key={dateItem.date}>
                    <div
                      className={'csDateItem' + (selectedDate === dateItem.date ? ' csDateItemActive' : '')}
                      onClick={() => this.handleDateSelect(dateItem.date)}
                    >
                      <p className="csDateDay">{dateItem.displayDay}</p>
                      <span className="csDateNum">{dateItem.displayDate}</span>
                    </div>
                    {index < slots.data.length - 1 && <div className="csDateDivider" />}
                  </div>
                ))}
              </div>
            </div>

            {/* Filter chips */}
            {groups.length > 0 && (
              <div className="csFilterSection">
                <div className="csFilterRow">
                  {groups.map((group) => (
                    <div
                      key={group.title}
                      className={'csFilterChip' + (selectedFilter === group.title ? ' csFilterChipActive' : '')}
                      onClick={() => this.handleFilterSelect(group.title)}
                    >
                      {group.icon && group.icon.active && (
                        <img
                          src={selectedFilter === group.title ? group.icon.active : group.icon.inactive}
                          alt={group.title}
                          className="csFilterIcon"
                        />
                      )}
                      <span className="csFilterText">{group.title}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Slot grid */}
            {selectedDate && (
              <div className="csSlotGridWrapper">
                {filteredSlots.length === 0 ? (
                  <p className="csNoSlots">{staticText.noSlots}</p>
                ) : (
                  <div>
                    <div className="csSlotGrid">
                      {visibleSlots.map((slot) => {
                        const isSelected = selectedSlot && selectedSlot.id === slot.id;
                        const isDisabled = slot.available_capacity === 0;
                        return (
                          <div
                            key={slot.id}
                            className={
                              'csSlotChip' +
                              (isSelected ? ' csSlotChipActive' : '') +
                              (isDisabled ? ' csSlotChipDisabled' : '')
                            }
                            onClick={() => !isDisabled && this.handleSlotSelect(slot)}
                          >
                            <p className="csSlotTime">{formatTime(slot.start, { unpaddedHours: true })}</p>
                          </div>
                        );
                      })}
                    </div>
                    {filteredSlots.length > Constants.SLOT_DISPLAY_CLAMP && (
                      <div
                        className="csViewMore"
                        onClick={() => this.setState({ showAllSlots: !showAllSlots })}
                      >
                        {showAllSlots ? staticText.viewLess : staticText.viewMore}
                        <img
                          src={ARROW_DOWN}
                          alt="arrow"
                          className={'csViewMoreArrow' + (showAllSlots ? ' csViewMoreArrowUp' : '')}
                          width="14"
                          height="14"
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

SlotBooking.propTypes = {
  slots: PropTypes.shape({
    dates: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.array,
    loading: PropTypes.bool,
    error: PropTypes.string,
    sectionInfo: PropTypes.object,
  }),
  onDateSelect: PropTypes.func,
  onSlotSelect: PropTypes.func,
};

SlotBooking.defaultProps = {
  slots: null,
  onDateSelect: null,
  onSlotSelect: null,
};

export default SlotBooking;
